/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DomainType, FaultFormat, HorizonFormat } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class SeismicImportClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags SeismicImport
   * @summary Импорт 2д съемки
   * @request POST:/seismicImport/api/v1/SeismicImport
   * @secure
   */
  seismicImportImportLocalSurvey2D = (
    data: {
      Files?: File[]
      /** @format uuid */
      ProjectId?: string
      Name?: string
      /** Типы доменов */
      DomainType?: DomainType
      /** @format int32 */
      'HeaderOffset.X'?: number
      /** @format int32 */
      'HeaderOffset.Y'?: number
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/SeismicImport`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    }) /**
   * No description
   *
   * @tags SeismicImport
   * @summary Дозагрузка профилей 2D съемки в уже существующиую съемку 2D
   * @request POST:/seismicImport/api/v1/SeismicImport/importToExistingSurvey
   * @secure
   */
  seismicImportImportToExistingSurvey2D = (
    data: {
      Files?: File[]
      /** @format uuid */
      SurveyId?: string
      /** @format uuid */
      ProjectId?: string
      SurveyName?: string
      /** Типы доменов */
      DomainType?: DomainType
      /** @format int32 */
      'HeaderOffset.X'?: number
      /** @format int32 */
      'HeaderOffset.Y'?: number
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/SeismicImport/importToExistingSurvey`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    }) /**
   * No description
   *
   * @tags SeismicImport
   * @summary Импорт 3д интерпретации горизонта
   * @request POST:/seismicImport/api/v1/SeismicImport/interpretation3d
   * @secure
   */
  seismicImportImportHorizonInterpretation3D = (
    data: {
      /** @format binary */
      File?: File
      /** @format uuid */
      SurveyId?: string
      /** @format uuid */
      ProjectId?: string
      Name?: string
      /** Типы доменов */
      DomainType?: DomainType
      /** Формат файла горизонта */
      HorizonFormat?: HorizonFormat
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/SeismicImport/interpretation3d`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    }) /**
   * No description
   *
   * @tags SeismicImport
   * @summary Импорт 32 интерпретации горизонта
   * @request POST:/seismicImport/api/v1/SeismicImport/interpretation2d
   * @secure
   */
  seismicImportImportHorizonInterpretation2D = (
    data: {
      /** @format binary */
      File?: File
      /** @format uuid */
      SurveyId?: string
      /** @format uuid */
      ProjectId?: string
      Name?: string
      /** Типы доменов */
      DomainType?: DomainType
      /** Формат файла горизонта */
      HorizonFormat?: HorizonFormat
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/SeismicImport/interpretation2d`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    }) /**
 * No description
 * 
 * @tags SeismicImport
 * @summary Импорт разлома в проект.
После импорта выполнится связывание всех разломов и кубов проекта, которые не были связаны ранее(на стороне сейсмики).
Связывание происходит асинхронно, в момент возврата ответа, еще может выполняться
 * @request POST:/seismicImport/api/v1/SeismicImport/fault/project/{projectId}
 * @secure
 */
  seismicImportImportFault = (
    projectId: string,
    data: {
      /** @format binary */
      File?: File
      Name?: string
      /** Типы доменов */
      DomainType?: DomainType
      /** Формат файла разлома */
      FaultFormat?: FaultFormat
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, string>({
      path: `/seismicImport/api/v1/SeismicImport/fault/project/${projectId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    })
}
